import React from 'react'
import tw, { styled } from 'twin.macro'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import Linkedin from '../images/LinkedIn-White.svg'
import Twitter from '../images/Twitter-White.svg'
import YouTube from '../images/YouTube-White.svg'

const SocialWrapper = styled.div`
  width: 89px;
  position: fixed;
  top: 35%;
  z-index: 100;
  @media (max-width: 640px) {
    display: none;
  }
`

const Social = ({}) => {
  return (
    <SocialWrapper tw="flex flex-col gap-10 bg-teal items-center py-8 rounded-r-lg">
      <div tw="w-6">
        <Link to="https://www.linkedin.com/company/quantics-io/">
          <img src={Linkedin} />
        </Link>
      </div>
      <div tw="w-6">
        <Link to="https://twitter.com/Quantics_io">
          <img src={Twitter} />
        </Link>
      </div>
      <div tw="w-6">
        <Link to="https://www.youtube.com/channel/UC9Qt0olS6u7IEiq8j8aSoeQ">
          <img src={YouTube} />
        </Link>
      </div>
    </SocialWrapper>
  )
}
export default Social
